import { useTranslation } from "react-i18next";
import { RowBody } from "../../../../components/RowValue/RowBody.jsx";
import { getClassName } from "../../../../components/Converter";

export default function PileheadSource({ value, set }) {
  const { t } = useTranslation("translation");

  function renderInput(value) {
    return (
      <select
        className={getClassName(value)}
        onChange={(e) => {
          set(e.target.value);
        }}
        name="pileheadSource"
        id="pileheadSource"
        value={value}
      >
        <option key={1} value={t("lvText.positionPileheads.pileheadSourceSmarttitan")}>
          {t("lvText.positionPileheads.pileheadSourceSmarttitan")}
        </option>
        <option key={2} value={t("lvText.positionPileheads.pileheadSourceDetailDrawings")}>
          {t("lvText.positionPileheads.pileheadSourceDetailDrawings")}
        </option>
      </select>
    );
  }

  return (
    <RowBody
      titleValue={<p>{t("lvText.positionPileheads.pileheadSource")}</p>}
      inputValue={renderInput(value)}
    />
  );
}
